module.exports = __webpack_public_path__ + "img/9000.a2b6c71f.jpg";